import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoPlayerSubtitlesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VideoPlayerSubtitles",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.91 4.63H3.09c-.6 0-1.09.49-1.09 1.09v15.31c0 .6.49 1.09 1.09 1.09h6.34v4.86c0 .32.38.5.63.3l6.3-5.15H28.9c.6 0 1.09-.49 1.09-1.09V5.72c0-.6-.49-1.09-1.09-1.09ZM4.44 9.08c0-.19.16-.35.35-.35h7.18c.19 0 .35.16.35.35v1.49c0 .19-.16.35-.35.35H4.79c-.19 0-.35-.16-.35-.35zm13.59 6.93c0 .19-.16.35-.35.35H4.79c-.19 0-.35-.16-.35-.35v-1.49c0-.19.16-.35.35-.35h12.89c.19 0 .35.16.35.35zm9.53 0c0 .19-.16.35-.35.35h-7.17c-.19 0-.35-.16-.35-.35v-1.49c0-.19.16-.35.35-.35h7.18c.19 0 .35.16.35.35v1.49Zm0-5.44c0 .19-.16.35-.35.35H14.32c-.19 0-.35-.16-.35-.35V9.08c0-.19.16-.35.35-.35h12.89c.19 0 .35.16.35.35z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.14 14.14H8.71a1.14 1.14 0 1 1 0-2.28h3.43a1.14 1.14 0 1 1 0 2.28M22.43 14.14h-5.71a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 27.86c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V7.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v11.43c0 1.89-1.54 3.43-3.43 3.43H9.19l-5.38 5.38c-.22.22-.51.33-.81.33M5.29 6.14c-.63 0-1.14.51-1.14 1.14v16.67l3.76-3.76c.21-.21.51-.33.81-.33h17.14c.63 0 1.14-.51 1.14-1.14V7.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
      })]
    })
  }));
};
VideoPlayerSubtitlesIcon.displayName = 'VideoPlayerSubtitlesIcon';